export const inputTypeMixin = {
  props: {
    /**
     * Name of the variable to use.
     */
    value: {
      required: true
    },

    /**
     * Defines if input field is disabled.
     */
    disabled: {
      type: Boolean,
      default: false
    },

    placeholder: {
      type: String
    },

    varName: {
      type: String
    },

    requiredFail: {
      type: Boolean
    }
  },

  computed: {
    fieldId() {
      if (this.varName) {
        return this.varName.replace(".", "");
      } else {
        return null;
      }
    }
  },

  methods: {
    updateValue(newValue) {
      this.$emit("updateValue", newValue);
    },
    updateValueNum(newValue) {
      this.$emit("updateValue", Number(newValue));
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/forms/dynamicObjectForms/inputTypeMixin.js